import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=615ba50a&scoped=true&"
import script from "./ImageCard.vue?vue&type=script&lang=js&"
export * from "./ImageCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageCard.vue?vue&type=style&index=0&id=615ba50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ba50a",
  null
  
)

export default component.exports